var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5283 11.2316L19.0721 15.6839C18.4776 16.2784 17.5064 16.2823 16.9114 15.6839L12.4524 11.2215C12.0847 11.5224 11.7568 11.8569 11.457 12.2202L15.9144 16.6809C16.4325 17.199 17.0983 17.4808 17.7781 17.5302C17.8494 17.5353 17.9213 17.5386 17.9926 17.5386C18.0639 17.5386 18.1352 17.5353 18.2065 17.5302C18.8852 17.4814 19.551 17.199 20.0691 16.6809L24.5338 12.2202C24.2345 11.8569 23.905 11.5297 23.5283 11.2316Z",
    fill: "#FF3300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4706 24.7572L16.9206 20.3111C17.5151 19.7166 18.4863 19.7126 19.0814 20.3111L23.5247 24.7577C23.903 24.4726 24.2359 24.138 24.5357 23.7748L20.0784 19.3141C19.5602 18.7959 18.8944 18.5141 18.2146 18.4647C18.1433 18.4596 18.0715 18.4563 18.0002 18.4563C17.9289 18.4563 17.8576 18.4596 17.7863 18.4647C17.1076 18.5135 16.4418 18.7959 15.9236 19.3141L11.459 23.7748C11.7582 24.138 12.1068 24.4653 12.4706 24.7572Z",
    fill: "#FF3300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5775 17.2926H9V18.7022H13.5775V17.2926Z",
    fill: "#FF3300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9993 17.2926H22.4219V18.7022H26.9993V17.2926Z",
    fill: "#FF3300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7045 22.4224H17.2949V26.9999H18.7045V22.4224Z",
    fill: "#FF3300"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7045 9H17.2949V13.5775H18.7045V9Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLogo);
export default __webpack_public_path__ + "static/media/button-logo.1733b19c24dcbba3d4fd8644072c732c.svg";
export { ForwardRef as ReactComponent };